(() => {
  if (window.__oddOneAiPreviewProtectionInstalled) return;
  window.__oddOneAiPreviewProtectionInstalled = true;

  const style = document.createElement('style');
  style.id = 'odd-one-ai-preview-protection-style';
  style.textContent = [
    '.odd-one-design-modal__result-image img[src],',
    '.odd-one-native-preview[data-visible="true"] img,',
    '.odd-one-live-preview[data-visible="true"] .odd-one-live-preview__art img,',
    '.cart-items__media-container img[data-odd-one-preview-url],',
    '.cart-items__media-container img[src*="/api/shopify/cart-preview/"] {',
    '-webkit-user-drag: none !important;',
    '-webkit-touch-callout: none !important;',
    'user-select: none !important;',
    '}',
  ].join('\n');
  document.head.appendChild(style);

  const protectedSurface = [
    '.odd-one-design-modal__result-image',
    '.odd-one-native-preview[data-visible="true"]',
    '.odd-one-live-preview[data-visible="true"] .odd-one-live-preview__art',
    '.cart-items__media-container',
  ].join(', ');

  const isProtected = (target) => {
    if (!(target instanceof Element)) return false;
    const surface = target.closest(protectedSurface);
    if (!surface) return false;
    if (surface.matches('.odd-one-design-modal__result-image')) {
      return Boolean(surface.querySelector('img[src]'));
    }
    if (surface.matches('.cart-items__media-container')) {
      return Boolean(surface.querySelector('img[data-odd-one-preview-url], img[src*="/api/shopify/cart-preview/"]'));
    }
    return true;
  };

  document.addEventListener('contextmenu', (event) => {
    if (isProtected(event.target)) event.preventDefault();
  }, true);
  document.addEventListener('dragstart', (event) => {
    if (isProtected(event.target)) event.preventDefault();
  }, true);
})();
